import { createSlice } from "@reduxjs/toolkit";

export const atencionSlices = createSlice({
  name: "atencion",
  initialState: {
    value: [],
    transicion: [],
    general: [],
    generalDetalle: [],
    estadistica: [],
    estadisticaAtencionData: [],
    estadisticaAtencionFields: [],
    operaciones: [],
    indicadores: [],
    cumplimiento: [],
    total: [],
    unidades: [],
    emisores: [],
    dataExcel: [],
    dataExcelIndicadores: [],
    dataExcelCumplimiento: [],
    cabeceraCumplimiento: [],
  },
  reducers: {
    addFiltro: (state, action) => {
      //
      state.value = action.payload;
    },
    addExcel: (state, action) => {
      //
      state.dataExcel = action.payload;
    },
    addExcelIndicadores: (state, action) => {
      //
      state.dataExcelIndicadores = action.payload;
    },
    addCabeceraCumplimiento: (state, action) => {
      //
      state.cabeceraCumplimiento = action.payload;
    },
    addExcelCumplimiento: (state, action) => {
      //
      state.dataExcelCumplimiento = action.payload;
    },
    addTransicion: (state, action) => {
      //
      state.transicion = action.payload;
    },
    addGeneral: (state, action) => {
      //
      state.general = action.payload;
    },
    addGeneralDetalle: (state, action) => {
      //
      state.generalDetalle = action.payload;
    },
    addEstadistica: (state, action) => {
      //
      state.estadistica = action.payload;
    },
    addEstadisticaAtencionData: (state, action) => {
      //
      state.estadisticaAtencionData = action.payload;
    },
    addEstadisticaAtencionFields: (state, action) => {
      //
      state.estadisticaAtencionFields = action.payload;
    },
    addOperaciones: (state, action) => {
      //
      state.operaciones = action.payload;
    },
    addIndicadores: (state, action) => {
      //
      state.indicadores = action.payload;
    },
    addCumplimiento: (state, action) => {
      //
      state.cumplimiento = action.payload;
    },
    addTotal: (state, action) => {
      //
      state.total = action.payload;
    },
    addUnidades: (state, action) => {
      //
      state.unidades = action.payload;
    },
    addEmisores: (state, action) => {
      //
      state.emisores = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  addFiltro,
  addTransicion,
  addGeneral,
  addEstadistica,
  addOperaciones,
  addIndicadores,
  addCumplimiento,
  addGeneralDetalle,
  addEstadisticaAtencionData,
  addEstadisticaAtencionFields,
  addTotal,
  addUnidades,
  addEmisores,
  addExcel,
  addExcelIndicadores,
  addExcelCumplimiento,
  addCabeceraCumplimiento,
} = atencionSlices.actions;

export default atencionSlices.reducer;
